<template>
 <div >
    <h2>Login</h2>
    <LoginForm v-if="!$store.getters.isLoggedIn" />
    <div v-else>
        <p>You are already logged in</p>
        <LogoutButton />
    </div>
 </div>
</template>

<script>
import LoginForm from '@/components/forms/login-form.vue'
import LogoutButton from '@/components/forms/logout-button.vue'

export default {
    name: 'Login',
    components: {
        LoginForm,
        LogoutButton
    }
}
</script>
